import { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';
import CustomTable from '../Table';

const AnnivesariesResult = ({
  members = [],
  onClickRow = () => {},
  onEdit = () => {},
  onDelete = () => {},
  handleOpenModal,
  handleNavigate,
  filterItem,
  options,
  headers,
  ...rest
}) => {
  const [page, setPage] = useState(0);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <Card {...rest}>
      <CustomTable
        data={members}
        dataKeysSequence={options ? [...options] :[
          'full_name',
          'plan',
          'membership_start_date',
          'batch',
          'trainer',
          "diet_plan"
        ]}
        headers={ headers ? [...headers] :[
          'Name',
          'Membership Plan',
          'Joining Date',
          'Father Name',
          'Batch',
          'Trainer',
          'Diet Plan',
        ]}
        handlePageChange={handlePageChange}
        handleOpenModal={handleOpenModal}
        handleNavigate={handleNavigate}
        page={page}
        onDelete={onDelete}
        onEdit={onEdit}
      />
    </Card>
  );
};

AnnivesariesResult.propTypes = {
  members: PropTypes.array.isRequired
};

export default AnnivesariesResult;
